import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_INTERVIEWS = "SET_INTERVIEWS";
export const SET_INTERVIEWS_TO_MANAGE = "SET_INTERVIEWS_TO_MANAGE";
export const SET_INTERVIEWS_FOR_HR = "SET_INTERVIEWS_FOR_HR";

export const SET_FORMS_FILTERS = "SET_FORMS_FILTERS";
export const SET_FORM_SURVEYS = "SET_FORM_SURVEYS";
export const SET_EMPLOYEES_TO_MANAGE = "SET_EMPLOYEES_TO_MANAGE";
export const SET_EMPLOYEES_OF_COMPANY = "SET_EMPLOYEES_OF_COMPANY";
export const SET_DEPARTMENTS_OF_COMPANY = "SET_DEPARTMENTS_OF_COMPANY";
export const SET_PERIODS = "SET_PERIODS";
export const SET_MANAGERS = "SET_MANAGERS";

export const SET_HR_TAB_ID = "SET_HR_TAB_ID";

export const SET_CURRENT_FORM = "SET_CURRENT_FORM";
export const SET_FORM_SECTIONS = "SET_FORM_SECTIONS";
export const SET_CURRENT_SECTION = "SET_CURRENT_SECTION";
export const SET_CURRENT_INTERVIEW = "SET_CURRENT_INTERVIEW";

export const FORMS_TO_MANAGE = "FORMS_TO_MANAGE";
export const HUMAN_RESOURCES = "HUMAN_RESOURCES";
export const MY_FORMS = "MY_FORMS";

export const SET_NB_WAITING_INTERVIEWS = "SET_NB_WAITING_INTERVIEWS";
export const SET_COMPANIES_WITH_EVALUATIONS = "SET_COMPANIES_WITH_EVALUATIONS";
